import addClass from '../../../general/class/addClass';
import child from '../../../general/child';
import isEmptyObject from '../../../general/isEmpty/isEmptyObject';
import removeClass from '../../../general/class/removeClass';

import * as exTimeout from '../../../utils/timeout';

import createDismissButton from './createDismissButton';
import getVariantClasses from './getVariantClasses';

// ----------------------------------------------------------------------------

function change(element: HTMLElement, config: Record<string, any> = {}): void {
    if (typeof config.type === 'string') {
        removeClass(element, getVariantClasses());
        addClass(element, 'alert-' + config.type);
    }

    if (config.title != null) {
        const elAlertHeader = element.querySelector<HTMLElement>('.alert-header');
        const elAlertHeaderTitle = element.querySelector<HTMLElement>('.alert-header-title');

        if (elAlertHeaderTitle) {
            child(elAlertHeaderTitle, config.title);
        } else if (elAlertHeader) {
            child(elAlertHeader, config.title);
        }
    }

    if (config.message != null) {
        const elAlertBody = element.querySelector<HTMLElement>('.alert-body');

        if (elAlertBody) {
            child(elAlertBody, config.message);
        } else {
            child(element, config.message);
        }
    }

    if (config.html != null) {
        child(element, config.html);
    }

    if (config.allowDismiss === true || element.hasClass('alert-dismissible')) {
        addClass(element, 'alert-dismissible');

        if (config.allowDismiss !== false && !element.querySelector('[data-bs-dismiss="alert"]')) {
            const dismissConfig = typeof config.allowDismiss === 'object' ? config.allowDismiss : {};
            const buttonDismiss = createDismissButton(element, dismissConfig);
            element.appendChild(buttonDismiss.element);
        }
    }

    if (config.timeout === true || !isEmptyObject(config.timeout)) {
        void exTimeout.start({
            merge: config.timeout,
            time: 2000,
            element: element,
            type: 'alert-timeout',
            fnAction: function (): any {
                element.hideElement();
            },
        });
    }
}

// ----------------------------------------------------------------------------

export default change;
